export enum Cookie {
  ACCESS_TOKEN = 'caa_auth_cookie_at',
  REFRESH_TOKEN = 'caa_auth_cookie_rt',
}
